import { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { 
  Box, 
  Stack, 
  Typography,
  Fab,
  TextField,
  Grid,
  Button
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useLocation } from "react-router-dom";
import { AlertMessage } from '../messages/AlertMessage';
import { ProductEntry } from './ProductEntry';
import { useAuth } from '../auth/AuthContext';
import { useNavigate } from "react-router";
import { NoAccessModal } from '../NoAccessModal';

const ProductPage = (props) =>  {

  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const { state } = useLocation();
  let navigate = useNavigate();

  const auth = useAuth()?.auth;

  useEffect(() => {
    const requestOptions = {
        method: 'GET'
    };
    
    fetch('/api/public/products?searchTerm=', requestOptions)
    .then(r => r.json())
    .then(res => {
        setRows(res);
    })
    .catch(err => {
        console.error(err);
    })
  }, []);

  const handleChangeSearch = (event) => {
      const requestOptions = {
          method: 'GET'
      };
      const val = event.target.value;

      fetch('/api/public/products?searchTerm='+val, requestOptions)
      .then(r => r.json())
      .then(res => setRows(res))
      .catch(err => console.error(err));
      
  };

  const handleAddProduct = () => {
    if(auth) {
      navigate('/product/add');
    } else {
      setOpen(true);
    }
  }

  return (
    <Box sx={{ flexGrow: 1, marginTop: '10px !important' }}>
      <Box sx={{ overflow: "auto" }}>
        <Box sx={{ width: "100%", boxSizing: 'border-box', display: "table", tableLayout: "fixed" }}>
          <AlertMessage 
            severity={'success'} 
            message={state?.message}
          />
          <Stack direction="row" spacing={2} sx={{ flexGrow: 1, margin: '20px', alignItems: 'center' }}>
            <Typography variant="h6" component="div">
              Produkte
            </Typography>
            <Fab onClick={() => handleAddProduct()} size="medium" color="primary" aria-label="add">
              <AddIcon />
            </Fab>
          </Stack>
          <Typography variant='body1' margin='20px'>
            Mit {<Fab style={{maxHeight: '20px', maxWidth: '20px', minHeight: '20px', minWidth: '20px'}}  color='primary'><AddIcon/></Fab>} kann ein neues Produkt hinzugefügt werden.<br/>
            Mit {<Fab style={{maxHeight: '20px', maxWidth: '20px', minHeight: '20px', minWidth: '20px'}} color='primary'><InfoIcon/></Fab>} kommt man zur persönglichen Empfehlung.
          </Typography>
          <TextField 
            label="Suche" 
            placeholder={'Suche nach Produkt'}
            onChange={(event) => handleChangeSearch(event)}
          />
          <Grid 
            container
            direction="row"
            sx={{
              marginTop: '20px',
              alignItems: "stretch",
            }} 
            spacing={4}
          >
            {rows?.length === 0 && 
            (<Box sx={{ marginTop: '20px !important', marginBottom: '20px !important' }}>
              <Typography sx={{marginLeft: '20px !important'}} variant="body2">
                Leider konnten wir keine Einträge finden, die deinem Produkt entsprechen. 
                Versuche es mit einem anderen Suchbegriff oder erstelle selbst einen neuen Eintrag.
              </Typography>
              <Button className="custom-button-root" href="/product/add">Neuen Eintrag erstellen</Button>
            </Box>)}
            {!!rows && rows?.map((row) => <ProductEntry
              id={row?.id} 
              name={row?.name} 
              barcode={row?.barcode}
              description={row?.description}
              handleChangeSearch={handleChangeSearch}  />)}
          </Grid>
        </Box>
      </Box>
      <NoAccessModal open={open} setOpen={setOpen}/>
    </Box>
  );
}

export default ProductPage;